var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodoIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#00E165"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M137.049 233.587L224.981 321.52L386.191 160.31",
    stroke: "white",
    strokeWidth: 85.8576
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.049 233.587L224.981 321.52L386.191 160.31",
    stroke: "white",
    strokeWidth: 53.661
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoIcn);
export default __webpack_public_path__ + "static/media/todo_icn.a1aa5a7460e032c81758a53afd9aec19.svg";
export { ForwardRef as ReactComponent };